import { render, staticRenderFns } from "./AutoOrderItem.vue?vue&type=template&id=54161538&scoped=true&"
import script from "./AutoOrderItem.vue?vue&type=script&lang=js&"
export * from "./AutoOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./AutoOrderItem.vue?vue&type=style&index=0&id=54161538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54161538",
  null
  
)

export default component.exports